import { Directive } from '@angular/core';
import { BaseComponent } from '@ups/xplat/core';

@Directive()
export abstract class AppSwitcherBaseComponent extends BaseComponent {}
